export function isNotUndefined<T>(input: T | undefined): input is T {
  return input !== undefined;
}
